export default "__VITE_ASSET__d1b93ef5__"